import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '../button/Button';
import Modal from '../modal/Modal';
import './WarningAlert.scss';

const WarningAlert = ({ message, onApprove, onCancel }) => {
    const approveButton = useRef();
    const icon = (
        <svg width="60.846" height="61.907" viewBox="0 0 60.846 61.907">
            <use xlinkHref="#svg-icon-error" />
        </svg>
    );

    useEffect(() => {
        approveButton.current.focus();
    }, []);

    return (
        <Modal className="warning-modal" icon={icon} message={message} isPortal isShown withIcon>
            <div className="buttons-section">
                <Button
                    className="btn btn-oval primary"
                    text="OK"
                    onClick={onApprove}
                    ref={approveButton}
                />
                {onCancel && <Button className="btn btn-oval" text="Cancel" onClick={onCancel} />}
            </div>
        </Modal>
    );
};

WarningAlert.propTypes = {
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    onApprove: PropTypes.func.isRequired,
    onCancel: PropTypes.func,
};
WarningAlert.defaultProps = {
    onCancel: null,
};
export default WarningAlert;
